import { render, staticRenderFns } from "./AddEmailForm.vue?vue&type=template&id=70747716&"
import script from "./AddEmailForm.vue?vue&type=script&lang=js&"
export * from "./AddEmailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports